import { render } from "./CaseShareView.vue?vue&type=template&id=549084d7&scoped=true"
import script from "./CaseShareView.vue?vue&type=script&lang=js"
export * from "./CaseShareView.vue?vue&type=script&lang=js"

import "./CaseShareView.vue?vue&type=style&index=0&id=549084d7&scoped=true&lang=css"

import exportComponent from "/Applications/phpstudy/bjhy/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549084d7"]])

export default __exports__